import NetworkBarWrapper from './NetworkBarWrapper';
import NetworkBarWrapperContainer from './NetworkBarWrapper.container';

export default NetworkBarWrapperContainer(NetworkBarWrapper);
